import React from "react";
import { FaSearch, FaFilter } from "react-icons/fa";

const SearchSection = ({
  searchTerm,
  setSearchTerm,
  showAdvancedSearch,
  setShowAdvancedSearch,
}) => {
  return (
    <div className="border border-brand-charcoal/15 bg-brand-cream p-4">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaSearch className="h-4 w-4 text-brand-muted" />
          </div>
          <input
            type="text"
            placeholder="Search by name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-brand-charcoal/20 rounded-lg bg-brand-cream focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
            aria-label="Search tournaments"
          />
        </div>

        <button
          onClick={() => setShowAdvancedSearch(!showAdvancedSearch)}
          className="inline-flex items-center px-4 py-2 border border-brand-charcoal/20 rounded-lg text-brand-charcoal bg-brand-cream hover:border-brand-gold-ink focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
          aria-expanded={showAdvancedSearch}
          aria-controls="advanced-filters"
        >
          <FaFilter className="h-4 w-4 mr-2" aria-hidden="true" />
          {showAdvancedSearch ? "Hide filters" : "Filters"}
        </button>
      </div>
    </div>
  );
};

export default SearchSection;
